export const RoleType = {
  USER: 'user',
  ORG_ADMIN: 'org_admin',
  ORG_OWNER: 'org_owner',
  POPIN_ADMIN: 'popin_admin'
};

export const roleTypeFromString = (role) => {
  const lower = (role || '').toLowerCase();
  switch (lower) {
    case RoleType.USER:
    case RoleType.ORG_ADMIN:
    case RoleType.ORG_OWNER:
    case RoleType.POPIN_ADMIN:
      return lower;
    default:
      throw Error(`Invalid role type: ${role}`);
  }
};
